import React from "react";
import { Box, Avatar, Typography } from "@mui/material/";
import {
    PictureAsPdf as PictureAsPdfIcon,
    BrokenImage
} from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";
import { useTheme } from "@mui/material/styles";
import clsx from "clsx";

const Thumbnail = ({
    item,
    index,
    selectedIndex,
    onClick,
    checkAvatarType,
    isPdf
}) => {
    const theme = useTheme();
    // const classes = makeStyles(styles)();
    const isPdfFile = isPdf(item.path);

    return (
        <Box key={`thumbnail_${item.id}_${index}`}>
            <Avatar
                // className={clsx([classes.auditImageThumb, selectedIndex])}
                sx={styles(theme).auditImageThumb}
                onClick={onClick(index)}
                src={isPdf(item.path) ? undefined : item.path}
                variant="square"
            >
                {isPdf(item.path) ? (
                    <PictureAsPdfIcon color="primary" />
                ) : (
                    <BrokenImage color="primary" />
                )}
            </Avatar>
            <Box sx={styles(theme).avatarIdentifier}>
                {checkAvatarType(item)}
            </Box>
        </Box>
    );
};

export default Thumbnail;
